
export enum MenuEntryStatus {
    NONE,
    VALIDATED,
    NEEDS_VALIDATION,
    INVALID,
}

export abstract class BaseMenuEntry
{
    /**
     * Get the main pictogram to display in the center of the entry.
     * Because we are in Webpack, this must be the return value of a
     * "require()" call.
     */
    public abstract getPicto() : string;

    /**
     * Returns whether the menu item should be enabled or not. When
     * disabled, a menu-item is not clickable, and if a navigation is
     * forced through the URL, the user will be redirected to the "app"
     * route by the router.
     */
    public abstract isEnabled() : boolean;

    /**
     * See the "Tucuxi GUI Software Usability Specification". The menu entry
     * should signal valid data when the data can be used by further tabs.
     */
    public abstract isValid() : boolean;

    /**
     * See the "Tucuxi GUI Software Usability Specification". The user has the
     * ability to manually validate the data. This can be done explicitly by clicking
     * on the status picto but can also be done implicitly by providing completing
     * some information.
     */
    public abstract isValidated() : boolean;

    /**
     * Called when the user clicks on the status picto of the menu entry.
     */
    public abstract toggleValidation() : void;

    public getStatus() : MenuEntryStatus
    {
        if (this.isValidated()) {
            return MenuEntryStatus.VALIDATED;
        }

        if (this.isValid()) {
            return MenuEntryStatus.NEEDS_VALIDATION;
        }

        return MenuEntryStatus.INVALID;
    }
}
